import { render, staticRenderFns } from "./v-gg-content.vue?vue&type=template&id=4b473c94&"
import script from "./v-gg-content.vue?vue&type=script&lang=js&"
export * from "./v-gg-content.vue?vue&type=script&lang=js&"
import style0 from "./v-gg-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports